var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.controlsPosition')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.controlsPosition),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "controlsPosition", $$v)
      },
      expression: "optionModel.controlsPosition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "default",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "right",
      "value": "right"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08572702","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-number/controlsPosition-editor.vue
// module id = null
// module chunks = 